import { NavLink } from 'react-router-dom';
import footerStyles from '../styles/component-footer.module.css';

function SupportBanner() {
  return (
    <div className={footerStyles.supportBanner}>
      <p>Love learning with LingoLeaf? We're a tiny two-person team keeping it free for everyone. Please consider <NavLink to="/support-us">supporting us</NavLink> on Buy Me a Coffee ☕</p>
    </div>
  );
}

function FooterBar() {
  return (
    <>
    <SupportBanner />
    <footer className={footerStyles.footer}>
      <nav className={footerStyles.nav}>
        <ul className={footerStyles.links}>
          <li><NavLink to="/about" className={footerStyles.link}>About</NavLink></li>
          <li><NavLink to="/news" className={footerStyles.link}>News</NavLink></li>
          <li><NavLink to="/faqs" className={footerStyles.link}>FAQs</NavLink></li>
          <li><NavLink to="/languages" className={footerStyles.link}>Languages</NavLink></li>
          <li><NavLink to="/future" className={footerStyles.link}>Future</NavLink></li>
          <li><NavLink to="/contact" className={footerStyles.link}>Contact</NavLink></li>
          <li><NavLink to="/privacy" className={footerStyles.link}>Privacy</NavLink></li>
          <li><NavLink to="/terms" className={footerStyles.link}>Terms</NavLink></li>
          <li><NavLink to="/support-us" className={footerStyles.link}>Support LingoLeaf</NavLink></li>
        </ul>
      </nav>
    </footer>
    </>
  );
}

export default FooterBar;